<template>
  <Layout :tituloPagina="'Network | Perfiles de velocidad | ' +(modo == 'nuevo' ? 'Nuevo' : 'Edición')">
    <div class="row">
      <div class="col-md-6">
        <div class="card">
          <div class="card-header justify-content-between d-flex align-items-center">
            <h4 class="card-title">
              {{ modo == 'nuevo' ? 'Nuevo' : '' }}
              {{ modo == 'edicion' ? 'Edición de' : '' }}
              perfil de velocidad
            </h4>
            <div>
              <div class="dropdown">
                <a
                  class="dropdown-toggle"
                  href="javascript: void(0);"
                  role="button"
                  data-bs-toggle="dropdown"
                  aria-expanded="false"
                >
                  <eva-icon
                    name="more-horizontal-outline"
                    data-eva-width="20"
                    data-eva-height="20"
                    :class="{
                      'fill-dark': $store.state.layout.layoutMode == 'light',
                      'fill-white': $store.state.layout.layoutMode == 'dark'
                    }"
                  ></eva-icon>
                </a>
                <ul class="dropdown-menu dropdown-menu-end">
                  <li>
                    <a
                      href="#"
                      class="dropdown-item"
                      onclick="return false"
                      @click="modo == 'nuevo' ? guardar() : actualizar()"
                      v-if="!bandera_spinner"
                    >
                      <i class="mdi mdi-content-save text-success"></i>
                      {{ modo == 'nuevo' ? 'Guardar' : 'Actualizar' }}
                    </a>
                    <span class="dropdown-item disabled" v-if="bandera_spinner">
                      <i class="mdi mdi-concourse-ci mdi-spin"></i>
                      {{ modo == 'nuevo' ? 'Guardar' : 'Actualizar' }}
                    </span>
                  </li>
                  <li>
                    <a
                      class="dropdown-item" href="#"
                      onclick="return false;" @click="cerrar()"
                    >
                      <i class="mdi mdi-close text-dark"></i>
                      Cerrar
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <div class="card-body">
            <div class="row align-items-center">
              <label class="col-md-2 ">
                Nombre
              </label>
              <div class="col-md-10">
                <input
                  class="form-control"
                  placeholder="Nombre del perfil"
                  ref="nombre"
                  v-model="perfil.nombre"
                />
              </div>
            </div>
            <br>
            <div class="row mb-3">
              <div class="col-md-6">
                <label for="">Velocidad de carga</label>
                <sup class="text-info" v-show="perfil.carga == 0">
                  0 indica velocidad ilimitada
                </sup>
                <div class="input-group">
                  <input
                    style="width: 75%;"
                    type="number"
                    class="form-control text-right"
                    min="0"
                    ref="carga"
                    placeholder="000"
                    v-model="perfil.carga"
                    @change="perfil.carga = valorValido(perfil.carga)"
                  />
                  <select
                    style="width: 25%;"
                    class="form-select"
                    ref="unidadCarga"
                    v-model="perfil.unidad_carga"
                  >
                    <option value="k">Kbps</option>
                    <option value="M">Mbps</option>
                  </select>
                </div>
              </div>
              <div class="col-md-6">
                <label for="">Velocidad de descarga</label>
                <sup class="text-info" v-show="perfil.descarga == 0">
                  0 indica velocidad ilimitada
                </sup>
                <div class="input-group">
                  <input
                    style="width: 75%;"
                    type="number"
                    class="form-control text-right"
                    min="0"
                    ref="descarga"
                    placeholder="000"
                    v-model="perfil.descarga"
                    @change="perfil.descarga = valorValido(perfil.descarga)"
                  />
                  <select
                    style="width: 25%;"
                    class="form-select"
                    ref="unidadDescarga"
                    v-model="perfil.unidad_descarga"
                  >
                    <option value="k">Kbps</option>
                    <option value="M">Mbps</option>
                  </select>
                </div>
              </div>
            </div>
            <div class="row align-items-center">
              <div class="col-md-6">
                <label>Estado</label>
                <div class="form-check form-switch form-switch-lg mb-3">
                  <input
                    :checked="perfil.activo"
                    @change="perfil.activo = !perfil.activo"
                    class="form-check-input"
                    type="checkbox"
                    id="banderaPerfilActivo"
                  />
                  <label class="form-check-label" for="banderaPerfilActivo"></label>
                </div>
              </div>
              <div class="col-md-3">
                <label>Burst</label>
                <div class="form-check form-switch form-switch-lg mb-3">
                  <input
                    :checked="perfil.burst"
                    @change="perfil.burst = !perfil.burst"
                    class="form-check-input"
                    type="checkbox"
                    id="activobursh"
                  />
                  <label class="form-check-label" for="activobursh"></label>
                </div>
              </div>
            </div>
            <div v-if="perfil.burst">
              <div class="row mb-3">
                <div class="col-md-6">
                  <label for="">Upload Burst Limit</label>
                  <div class="input-group">
                    <input
                      style="width: 75%;"
                      type="number"
                      class="form-control text-right"
                      min="0"
                      ref="cargaBurstLimit"
                      placeholder="000"
                      v-model="perfil.carga_burst_limit"
                      @change="perfil.carga_burst_limit = valorValido(perfil.carga_burst_limit)"
                    />
                    <select
                      style="width: 25%;"
                      class="form-select"
                      ref="unidadCargaBurstLimit"
                      v-model="perfil.unidad_carga_burst_limit"
                    >
                      <option value="k">Kbps</option>
                      <option value="M">Mbps</option>
                      <option value="G">Gbps</option>
                    </select>
                  </div>
                </div>
                <div class="col-md-6">
                  <label for="">Download Burst Limit</label>
                  <div class="input-group">
                    <input
                      style="width: 75%;"
                      type="number"
                      class="form-control text-right"
                      min="0"
                      ref="descargaBurstLimit"
                      placeholder="000"
                      v-model="perfil.descarga_burst_limit"
                      @change="perfil.descarga_burst_limit = valorValido(perfil.descarga_burst_limit)"
                    />
                    <select
                      style="width: 25%;"
                      class="form-select"
                      ref="unidadDescargaBurstLimit"
                      v-model="perfil.unidad_descarga_burst_limit"
                    >
                      <option value="k">Kbps</option>
                      <option value="M">Mbps</option>
                      <option value="G">Gbps</option>
                    </select>
                  </div>
                </div>
              </div>
              <div class="row mb-3">
                <div class="col-md-6">
                  <label for="">Upload Burst Threshold</label>
                  <div class="input-group">
                    <input
                      style="width: 75%;"
                      type="number"
                      class="form-control text-right"
                      min="0"
                      ref="cargaBurstThreshold"
                      placeholder="000"
                      v-model="perfil.carga_burst_threshold"
                      @change="perfil.carga_burst_threshold = valorValido(perfil.carga_burst_threshold)"
                    />
                    <select
                      style="width: 25%;"
                      class="form-select"
                      ref="unidadCargaBurstThreshold"
                      v-model="perfil.unidad_carga_burst_threshold"
                    >
                      <option value="k">Kbps</option>
                      <option value="M">Mbps</option>
                      <option value="G">Gbps</option>
                    </select>
                  </div>
                </div>
                <div class="col-md-6">
                  <label for="">Download Burst Threshold</label>
                  <div class="input-group">
                    <input
                      style="width: 75%;"
                      type="number"
                      class="form-control text-right"
                      min="0"
                      ref="descargaBurstThreshold"
                      placeholder="000"
                      v-model="perfil.descarga_burst_threshold"
                      @change="perfil.descarga_burst_threshold = valorValido(perfil.descarga_burst_threshold)"
                    />
                    <select
                      style="width: 25%;"
                      class="form-select"
                      ref="unidadDescargaBurstThreshold"
                      v-model="perfil.unidad_descarga_burst_threshold"
                    >
                      <option value="k">Kbps</option>
                      <option value="M">Mbps</option>
                      <option value="G">Gbps</option>
                    </select>
                  </div>
                </div>
              </div>
              <div class="row mb-3">
                <div class="col-md-6">
                  <label for="">Upload Burst Time</label>
                  <div class="input-group">
                    <input
                      style="width: 75%;"
                      type="number"
                      class="form-control text-right"
                      min="0"
                      ref="cargaBurstTime"
                      placeholder="000"
                      v-model="perfil.carga_burst_time"
                      @change="perfil.carga_burst_time = valorValido(perfil.carga_burst_time)"
                    />
                    <span class="input-group-text">
                      S
                    </span>
                  </div>
                </div>
                <div class="col-md-6">
                  <label for="">Download Burst Time</label>
                  <div class="input-group">
                    <input
                      style="width: 75%;"
                      type="number"
                      class="form-control text-right"
                      min="0"
                      ref="descargaBurstTime"
                      placeholder="000"
                      v-model="perfil.descarga_burst_time"
                      @change="perfil.descarga_burst_time = valorValido(perfil.descarga_burst_time)"
                    />
                    <span class="input-group-text">
                      S
                    </span>
                  </div>
                </div>
              </div>
            </div>

            <hr>
            <h4>PPPoE</h4>

            <div class="row">
              <div class="col-md-6">
                <label class="form-label">Only One</label>
                <select v-model="perfil.only_one_pppoe" class="form-select">
                  <option :value="null">Default</option>
                  <option :value="1">Yes</option>
                  <option :value="0">No</option>
                </select>
              </div>
            </div>
          </div>
        </div>
        <div class="text-right">
          <div class="btn-group">
            <button @click="atras()" class="btn btn-secondary">
              <i class="mdi mdi-chevron-left"></i>
              Atras
            </button>
  
            <button
              class="btn btn-success"
              @click="modo == 'nuevo' ? guardar() : actualizar()"
              :disabled="bandera_spinner"
            >
              <i
                class="mdi"
                :class="!bandera_spinner ? 'mdi-content-save' : 'mdi-concourse-ci mdi-spin'"
              ></i>
              {{ modo == 'nuevo' ? 'Guardar' : 'Actualizar' }}
            </button>
          </div>
        </div>
      </div>
    </div>
    <br>
  </Layout>
</template>

<script>
import PerfilVelocidadCpesSrv from '@/services/PerfilVelocidadCpesSrv.js'
import Layout from "@/views/layouts/main.vue"

export default {
  name: 'EdicionPerfilVelocidad',
  components: {
    Layout
  },
  data() {
    return {
      modo: 'nuevo',
      perfil: {
        nombre: '',

        carga: 0,
        descarga: 0,
        unidad_carga: 'M',
        unidad_descarga: 'M',
        activo: 1,

        burst: 0,

        carga_burst_limit: 0,
        carga_burst_threshold: 0,
        carga_burst_time: 0,
        descarga_burst_limit: 0,
        descarga_burst_threshold: 0,
        descarga_burst_time: 0,
        unidad_carga_burst_limit: 'M',
        unidad_carga_burst_threshold: 'M',
        unidad_descarga_burst_limit: 'M',
        unidad_descarga_burst_threshold: 'M',
        only_one_pppoe: null
      },
      perfilIni: {
        nombre: '',

        carga: 0,
        descarga: 0,
        unidad_carga: 'M',
        unidad_descarga: 'M',
        activo: 1,

        burst: 0,

        carga_burst_limit: 0,
        carga_burst_threshold: 0,
        carga_burst_time: 0,
        descarga_burst_limit: 0,
        descarga_burst_threshold: 0,
        descarga_burst_time: 0,
        unidad_carga_burst_limit: 'M',
        unidad_carga_burst_threshold: 'M',
        unidad_descarga_burst_limit: 'M',
        unidad_descarga_burst_threshold: 'M',
        only_one_pppoe: null
      },
      bandera_spinner: false
    }
  },

  created() {
    var self = this

    Object.assign(self.perfilIni, self.perfil)

    // Modo
    if (this.$route.path.indexOf('nuevo') >= 0) self.modo = 'nuevo'
    else self.modo = 'edicion'

    // Cargas iniciales
    if (self.modo == 'edicion') self.cargarPerfil()
  },

  methods: {
    actualizar: function() {
      var self = this
      var perfil = Object.assign({}, this.perfil)

      self.bandera_spinner = true

      if(perfil.nombre == '' || perfil.nombre == null) {
        iu.msg.warning('Es necesario un nombre para el perfil de velocidad')
        self.$refs.nombre.select()
        self.bandera_spinner = false
        return
      }

      if (perfil.unidad_carga == 'k' && perfil.carga > 4294967) {
        iu.msg.warning('Es necesario seleccionar un valor menor que 4294967')
        self.$refs.carga.select()
        self.bandera_spinner = false
        return
      } else if (perfil.unidad_carga == 'M' && perfil.carga > 4294) {
        iu.msg.warning('Es necesario seleccionar un valor menor que 4294')
        self.$refs.carga.select()
        self.bandera_spinner = false
        return
      }

      if (perfil.unidad_descarga == 'k' && perfil.descarga > 4294967) {
        iu.msg.warning('Es necesario seleccionar un valor menor a 4294967')
        self.$refs.descarga.select()
        self.bandera_spinner = false
        return
      } else if (perfil.unidad_descarga == 'M' && perfil.descarga > 4294) {
        iu.msg.warning('Es necesario seleccionar un valor menor a 4294')
        self.$refs.descarga.select()
        self.bandera_spinner = false
        return
      }

      if ( perfil.burst ) {
        if( self.calcularBits(perfil.carga, perfil.unidad_carga) >= self.calcularBits(perfil.carga_burst_limit, perfil.unidad_carga_burst_limit) ) {
          iu.msg.warning('El valor ingresado debe ser superior a la velocidad de carga')
          self.$refs.cargaBurstLimit.select()
          self.bandera_spinner = false
          return
        }

        if( self.calcularBits(perfil.descarga, perfil.unidad_descarga) >= self.calcularBits(perfil.descarga_burst_limit, perfil.unidad_descarga_burst_limit) ) {
          iu.msg.warning('El valor ingresado debe ser superior a la velocidad de descarga')
          self.$refs.descargaBurstLimit.select()
          self.bandera_spinner = false
          return
        }

        if( self.calcularBits(perfil.carga_burst_limit, perfil.unidad_carga_burst_limit) < self.calcularBits(perfil.carga_burst_threshold, perfil.unidad_carga_burst_threshold) ) {
          iu.msg.warning('El valor ingresado no debe superar el valor de Upload Burst Limit.')
          self.$refs.cargaBurstThreshold.select()
          self.bandera_spinner = false
          return
        }

        if( self.calcularBits(perfil.descarga_burst_limit, perfil.unidad_descarga_burst_limit) < self.calcularBits(perfil.descarga_burst_threshold, perfil.unidad_descarga_burst_threshold) ) {
          iu.msg.warning('El valor ingresado no debe superar el valor de Download Burst Limit.')
          self.$refs.descargaBurstThreshold.select()
          self.bandera_spinner = false
          return
        }

        perfil.burst_limit = perfil.carga_burst_limit+perfil.unidad_carga_burst_limit+'/'+perfil.descarga_burst_limit+perfil.unidad_descarga_burst_limit
        perfil.burst_threshold = perfil.carga_burst_threshold+perfil.unidad_carga_burst_threshold+'/'+perfil.descarga_burst_threshold+perfil.unidad_descarga_burst_threshold
        perfil.burst_time = perfil.carga_burst_time+'/'+perfil.descarga_burst_time
      } else {
        perfil.burst_limit = '0/0'
        perfil.burst_threshold = '0/0'
        perfil.burst_time = '0/0'
      }
      
      PerfilVelocidadCpesSrv.actualizar(perfil).then(response => {
        iu.msg.success('Se actualizó correctamente')
      }).catch(error => {
        let mensaje
        try {
          mensaje = error.response.data.message
        } catch (e) {
          mensaje = 'No se pudo actualizar'
        }
        iu.msg.error(mensaje)
        console.log(error)
      }).finally(() => {
        self.bandera_spinner = false
      })
    },

    atras: function() {
      this.$router.go(-1)
    },

    cargarPerfil: function() {
      var self = this

      PerfilVelocidadCpesSrv.perfilJSON(self.$route.params.id).then(response => {
        var perfil = response.data
        Object.assign(self.perfil, perfil)

        let burstLimit = self.separarValor(self.perfil.burst_limit)
        self.perfil.carga_burst_limit = burstLimit[0].valor
        self.perfil.unidad_carga_burst_limit = burstLimit[0].unidad
        self.perfil.descarga_burst_limit = burstLimit[1].valor
        self.perfil.unidad_descarga_burst_limit = burstLimit[1].unidad

        let burstThreshold = self.separarValor(self.perfil.burst_threshold)
        self.perfil.carga_burst_threshold = burstThreshold[0].valor
        self.perfil.unidad_carga_burst_threshold = burstThreshold[0].unidad
        self.perfil.descarga_burst_threshold = burstThreshold[1].valor
        self.perfil.unidad_descarga_burst_threshold = burstThreshold[1].unidad

        let burstTime = self.perfil.burst_time.split("/")
        self.perfil.carga_burst_time = burstTime[0]
        self.perfil.descarga_burst_time = burstTime[1]
      }).catch(error => {
        let mensaje
        try {
          mensaje = error.response.data.message
        } catch (e) {
          mensaje = 'No se pudo cargar el perfil de velocidad'
        }
        iu.msg.error(mensaje)
        console.log(error)
      })
    },

    separarValor: function(cadena) {
      var partes = cadena.split("/")

      var resultado = partes.map(parte => {
        if (parte === "0") {
          return { valor: 0, unidad: "k" }
        }

        var match = parte.match(/^(\d+)([a-zA-Z]+)$/)
        return {
          valor: parseInt(match[1], 10),
          unidad: match[2]
        }
      })

      return resultado
    },

    cerrar: function() {
      this.atras()
    },

    guardar: function() {
      var self = this
      var perfil = Object.assign({}, this.perfil)

      self.bandera_spinner = true

      if(perfil.nombre == '' || perfil.nombre == null) {
        iu.msg.warning('Es necesario un nombre para el perfil de velocidad')
        self.$refs.nombre.select()
        self.bandera_spinner = false
        return
      }

      if (perfil.unidad_carga == 'k' && perfil.carga > 4294967) {
        iu.msg.warning('Es necesario seleccionar un valor menor que 4294967')
        self.$refs.carga.select()
        self.bandera_spinner = false
        return
      } else if (perfil.unidad_carga == 'M' && perfil.carga > 4294) {
        iu.msg.warning('Es necesario seleccionar un valor menor que 4294')
        self.$refs.carga.select()
        self.bandera_spinner = false
        return
      }

      if (perfil.unidad_descarga == 'k' && perfil.descarga > 4294967) {
        iu.msg.warning('Es necesario seleccionar un valor menor a 4294967')
        self.$refs.descarga.select()
        self.bandera_spinner = false
        return
      } else if (perfil.unidad_descarga == 'M' && perfil.descarga > 4294) {
        iu.msg.warning('Es necesario seleccionar un valor menor a 4294')
        self.$refs.descarga.select()
        self.bandera_spinner = false
        return
      }

      if ( perfil.burst ) {
        if( self.calcularBits(perfil.carga, perfil.unidad_carga) >= self.calcularBits(perfil.carga_burst_limit, perfil.unidad_carga_burst_limit) ) {
          iu.msg.warning('El valor ingresado debe ser superior a la velocidad de carga')
          self.$refs.cargaBurstLimit.select()
          self.bandera_spinner = false
          return
        }

        if( self.calcularBits(perfil.descarga, perfil.unidad_descarga) >= self.calcularBits(perfil.descarga_burst_limit, perfil.unidad_descarga_burst_limit) ) {
          iu.msg.warning('El valor ingresado debe ser superior a la velocidad de descarga')
          self.$refs.descargaBurstLimit.select()
          self.bandera_spinner = false
          return
        }

        if( self.calcularBits(perfil.carga_burst_limit, perfil.unidad_carga_burst_limit) < self.calcularBits(perfil.carga_burst_threshold, perfil.unidad_carga_burst_threshold) ) {
          iu.msg.warning('El valor ingresado no debe superar el valor de Upload Burst Limit.')
          self.$refs.cargaBurstThreshold.select()
          self.bandera_spinner = false
          return
        }

        if( self.calcularBits(perfil.descarga_burst_limit, perfil.unidad_descarga_burst_limit) < self.calcularBits(perfil.descarga_burst_threshold, perfil.unidad_descarga_burst_threshold) ) {
          iu.msg.warning('El valor ingresado no debe superar el valor de Download Burst Limit.')
          self.$refs.descargaBurstThreshold.select()
          self.bandera_spinner = false
          return
        }

        perfil.burst_limit = perfil.carga_burst_limit+perfil.unidad_carga_burst_limit+'/'+perfil.descarga_burst_limit+perfil.unidad_descarga_burst_limit
        perfil.burst_threshold = perfil.carga_burst_threshold+perfil.unidad_carga_burst_threshold+'/'+perfil.descarga_burst_threshold+perfil.unidad_descarga_burst_threshold
        perfil.burst_time = perfil.carga_burst_time+'/'+perfil.descarga_burst_time
      } else {
        perfil.burst_limit = '0/0'
        perfil.burst_threshold = '0/0'
        perfil.burst_time = '0/0'
      }

      PerfilVelocidadCpesSrv.guardar(perfil).then(response => {
        iu.msg.success('Se guardó el perfil')
        Object.assign(self.perfil, self.perfilIni)
      }).catch(error => {
        let mensaje
        try {
          mensaje = error.response.data.message
        } catch (e) {
          mensaje = 'No se pudo guardar el perfil'
        }
        iu.msg.error(mensaje)
        console.log(error)
      }).finally(() => {
        self.bandera_spinner = false
      })
    },

    calcularBits: function(total, tipo){
      if(tipo == 'k') return total * 1024
      if(tipo == 'M') return total * 1048576
      if(tipo == 'G') return total * 1073741824
    },

    valorValido: function(valor) {
      if (isNaN(valor) || valor < 0) {
        iu.msg.warning('Es necesario valores positivos no menores a 0')
        return 0
      }

      valor = parseFloat(valor)

      if (valor != valor.toFixed(3)) {
        iu.msg.warning('Solo se permite una precisión de 3 decimales')
        return valor.toFixed(3)
      }

      return valor
    }
  },
}
</script>

<style scoped>
.form-check-input:checked {
  background-color: #63AD6F;
  border-color: #63AD6F;
}
</style>